(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["degeler-partners-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-partners-section]');

    sections.forEach((sectionEl) => {
      const tabs = Array.from(sectionEl.querySelectorAll('[data-partner-tab]'));
      const details = Array.from(sectionEl.querySelectorAll('[data-partner-detail]'));
      const mediaItems = Array.from(sectionEl.querySelectorAll('[data-partner-media]'));

      if (!tabs.length || !details.length || !mediaItems.length) return;

      const seconds = Number(sectionEl.dataset.autoSeconds);
      const delay = Number.isFinite(seconds) && seconds > 0 ? seconds * 1000 : 8000;
      let activeIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      if (activeIndex < 0) activeIndex = 0;
      let intervalId;

      const activate = (index) => {
        const clampedIndex = ((index % tabs.length) + tabs.length) % tabs.length;
        activeIndex = clampedIndex;

        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === clampedIndex;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        details.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === clampedIndex);
        });

        mediaItems.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === clampedIndex);
        });
      };

      const startAuto = () => {
        if (tabs.length < 2) return;
        clearInterval(intervalId);
        intervalId = window.setInterval(() => {
          activate(activeIndex + 1);
        }, delay);
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = Number(tab.dataset.index);
          activate(index);
          startAuto();
        });

        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            activate(activeIndex + 1);
            tabs[activeIndex].focus();
            startAuto();
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            activate(activeIndex - 1);
            tabs[activeIndex].focus();
            startAuto();
          }
        });
      });

      activate(activeIndex);
      startAuto();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
